export interface AboutSection {
  id: string;
  label: string;
}

export const ABOUT_SECTIONS: AboutSection[] = [
  { id: 'about', label: 'About Us' },
  { id: 'goals', label: 'Strategic goals' },
  { id: 'mission', label: 'Mission, vision, and values' },
  { id: 'personnel', label: 'Network personnel' },
];

export const ABOUT_INTRO =
  'The Ontario Regional Blood Coordinating Network (ORBCoN) was launched in 2006 and the program is funded by the Ontario Ministry of Health (MOH) to provide an organized and integrated approach to blood management in Ontario through the engagement of hospitals and Canadian Blood Services. ORBCoN supports the implementation of the provincial Blood Utilization Strategy using the following five strategic goals: 1. Utilization of blood components and products; 2. Educational Resources; 3. Inventory Management; 4. Communication; and, 5. Quality and Safety.';

export const ABOUT_GOALS: { title: string; items: string[] }[] = [
  {
    title: 'Utilization of blood components and products',
    items: ['IVIG Utilization', 'Centralized Utilization Database', 'Data Strategy', 'Provincial Audits'],
  },
  {
    title: 'Educational Resources',
    items: [
      'Evaluation of Educational Resources',
      'Maintenance of Existing Resources',
      'Implementation of New Resources',
      'Educational Events Hosted by ORBCoN',
      'Educational Events - National or International',
    ],
  },
  {
    title: 'Inventory Management',
    items: ['Contingency Planning', 'Benchmark Levels for Outdate Rates', 'Redistribution Program'],
  },
  {
    title: 'Communication',
    items: [
      'Newsletter',
      'Collaborative Hospital Site Visits',
      'Distribution of Resources',
      'Transfusion Ontario Website',
    ],
  },
  {
    title: 'Quality and Safety',
    items: [
      'Provincial Quality Strategy',
      'Accreditation Requirements for Transfusion Medicine',
      'Improve Patient Safety',
      'Physician/Nursing Education Strategy',
    ],
  },
];

export const ABOUT_MISSION = 'Inspiring and facilitating best transfusion practices in Ontario.';

export const ABOUT_VISION =
  'We do our work in support of our vision of appropriate and safe transfusion practices for every Ontarian, every time.';

export const ABOUT_VALUES: { label: string; text: string }[] = [
  {
    label: 'Patient Safety',
    text: 'We promote optimal transfusion practices for the best patient care.',
  },
  {
    label: 'Accountability',
    text: 'We share accountability with providers, hospital partners, the Ministry and Canadian Blood Services (CBS) to continually improve the blood system in Ontario.',
  },
  {
    label: 'Leading Practice',
    text: 'We use evidence to inform what we do, produce and share.',
  },
  {
    label: 'Collaboration',
    text: 'We cultivate relationships and support sharing knowledge and expertise for better outcomes.',
  },
  {
    label: 'Quality',
    text: 'We strive to produce supports that help our users achieve desired outcomes and continuously improve quality.',
  },
];

export const ABOUT_PERSONNEL =
  'ORBCoN is comprised of three regional offices across Ontario. Each office operates with a Project Sponsor, Regional Manager, and Regional Project Coordinators. One regional office is our program lead. In addition, housed in our Northern and Eastern Ontario office we employ a program administrator, website administrator, and an information technology analyst. Clinical expertise is available from our Physician Clinical Project Coordinator and the Nursing Clinical Project Coordinator.';
